import Cookies from 'cookies'
import { MyAccount } from 'features/User/MyAccount'
import { GetServerSidePropsContext } from 'next'
import useTranslation from 'next-translate/useTranslation'
import Head from 'next/head'
import { FetchPets } from '../../api/queries/useFetchPets'
import { FetchProductSubscriptions } from '../../api/queries/useFetchProductSubscriptions'
import { ApiClient } from '../../services/ApiClient'
import { CookieKeys } from '../../services/Cookies'
import { getPayloadFromJWT } from '../../utils/jwt'
import { FetchPetDetails } from '../../api/queries/useFetchPetDetails'

//route user to current orders
export const getServerSideProps = async (ctx: GetServerSidePropsContext) => {
  const clientJWT = ctx.req.cookies[CookieKeys.SESSION]
  const query = ctx.query
  const guestIdentifier = query?.ownerId ?? ctx.req.cookies[CookieKeys.GUEST_ID]
  const cookies = new Cookies(ctx.req, ctx.res)
  try {
    let userId = guestIdentifier

    if (!clientJWT) {
      return {
        redirect: {
          destination: '/login',
          permanent: false,
        },
      }
    }
    
    userId = getPayloadFromJWT(clientJWT).sub
    cookies.set(CookieKeys.GUEST_ID) // Delete the cookie, just in case

    return {
      redirect: {
        destination: `/user/orders/current`,
        permanent: false,
      },
    }
  } catch (err) {
    //failsafe for expired JWT tokens
    cookies.set(CookieKeys.SESSION)
    return {
      redirect: {
        destination: '/login',
        permanent: false,
      },
    }
  }
}

export default function User() {
  const { t } = useTranslation()

  return (
    <div>
      <Head>
        <title>{t('my-account:page-title')}</title>
        <meta name="title" content={t('my-account:meta-title')} />
        <meta name="description" content={t('my-account:meta-description')} />
      </Head>

      <main>
        <MyAccount />
      </main>
    </div>
  )
}
